import { apiInstance, legacyV2Path, legacyV3Path } from '../index'
import { mapArgs } from 'corp-front-vue-commons/src/utils/functions'

const employee = {
  get (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2Path()}/employee`,
      params
    })
  },

  getById (id) {
    return apiInstance({
      method: 'GET',
      url: `${legacyV2Path()}/employee/${id}`
    })
  },

  create (data) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV2Path()}/employee`,
      data
    })
  },

  update (id, data) {
    return apiInstance({
      method: 'PUT',
      url: `${legacyV2Path()}/employee/${id}`,
      data
    })
  },

  delete (id) {
    return apiInstance({
      method: 'DELETE',
      url: `${legacyV2Path()}/employee/${id}`
    })
  },

  multiDelete (companyId, data) {
    return apiInstance({
      method: 'DELETE',
      url: `${legacyV2Path()}/company/${companyId}/employees`,
      data
    })
  },

  getCompanyNameFirstAccess (id, ...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV3Path()}/employee/${id}/firstAccess`,
      params
    })
  },

  setEmployeeDataFirstAccess (id, data) {
    return apiInstance({
      method: 'PUT',
      url: `${legacyV3Path()}/employee/${id}/firstAccess`,
      data
    })
  },

  resendWelcomeEmail (employeeId) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV2Path()}/employee/${employeeId}/resendWelcomeEmail`
    })
  },

  addToAllCostCenters (employeeId, data) {
    return apiInstance({
      method: 'PUT',
      url: `${legacyV2Path()}/employee/${employeeId}/addToAllCostCenters`,
      data
    })
  },

  export (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: '/b2b-legacy-report/employee/export',
      timeout: 60000,
      responseType: 'blob',
      params
    })
  },

  addInBulk (data) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV2Path()}/employee/wizard`,
      data
    })
  },

  sendSMS (data) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV2Path()}/employee/wizard/phoneNumbers`,
      data
    })
  },

  searchPhoneNumber (phone) {
    return apiInstance({
      methos: 'GET',
      url: `${legacyV2Path()}/employee/phone/${phone}`
    })
  },

  batchUpdate (companyId, ...args) {
    const data = mapArgs(...args)

    return apiInstance({
      method: 'POST',
      url: `${legacyV2Path()}/company/${companyId}/employee/batchUpdate`,
      timeout: 60000,
      data
    })
  },

  multiDeleteById (companyId, data) {
    return apiInstance({
      method: 'DELETE',
      url: `${legacyV3Path()}/company/${companyId}/employees/multiDelete`,
      data
    })
  },

  bulkImport (company, formData, shouldSendWelcomeEmail = true) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV2Path()}/company/${company}/employee/upload`,
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000,
      data: formData,
      params: {
        shouldSendWelcomeEmail
      }
    })
  }
}

export default employee
